import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from '@/components/ui/card';

export const ManagementCard = ({ person, index = 0 }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
        >
            <Card className="h-full w-96 overflow-hidden border-2 hover:border-primary transition-all duration-300 hover:shadow-xl group">
                {/* Image */}
                <div className="relative overflow-hidden bg-muted">
                    <img
                        src={person.image}
                        alt={person.name}
                        className="w-full h-full object-cover transform transition-transform duration-500 group-hover:scale-110"
                    />
                </div>

                <CardContent className="p-6">
                    <div className="mb-4">
                        <h3 className="text-xl font-heading font-bold text-foreground mb-1">
                            {person.name}
                        </h3>
                        <p className="text-sm text-secondary font-semibold">
                            {person.designation}
                        </p>
                    </div>
                </CardContent>
            </Card>
        </motion.div>
    );
};
